module.exports = __webpack_public_path__ + "static/img/guard_u.df20c00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard_u.png
// module id = UHrP
// module chunks = 1